import CheckBox from 'client/components/common/CheckBox/CheckBox'
import _ from 'lodash'
import React from 'react'

interface MappingRowsProps {
  fileContent: string[][]
  skip: number[]
  setSkip: React.Dispatch<React.SetStateAction<number[]>>
}

const MappingRows: React.FC<MappingRowsProps> = ({ fileContent, skip, setSkip }) => {
  return (
    <>
      {fileContent.map((row, i) => {
        const value = !skip.includes(i)
        return (
          <React.Fragment key={`col-${i}`}>
            <div className="mapping-view__grid-checkbox">
              <CheckBox
                value={value}
                onChange={(value) => {
                  const newSkip = [...skip]
                  if (value) {
                    _.pull(newSkip, i)
                  } else {
                    newSkip.push(i)
                  }
                  setSkip(_.uniq(newSkip))
                }}
              />
            </div>
            {row.map((el, n) => {
              return (
                <div key={`row-${n}`} className="mapping-view__grid-element">
                  {el}
                </div>
              )
            })}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default MappingRows
